import { useNavigate } from 'react-router-dom';

export const LoginBackBtn = ({}) => {
    const navigate = useNavigate();

    return (
        <button className="back-to-sign-in" onClick={() => navigate('/login')}>
            ← Back to Sign In
        </button>
    );
};
